import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { useCheckoutStore } from "../../modules/account/store/useCheckoutStore";
import { BASE_ROUTE } from "../../modules/account/models/routes";

const CheckoutDrawer = lazy(
  () => import("../../modules/account/components/CheckoutDrawer/CheckoutDrawer")
);

/**
 * Instancia global del CheckoutDrawer para comprar FUERA de Mi Cuenta
 * (pantalla de bloqueo por plan, modal de límite). Es el mismo drawer de la
 * spec 031: "el CheckoutDrawer es EL checkout", no se redirige a otra vista.
 *
 * Dentro de /mi-cuenta NO se monta: allí el módulo ya tiene su propia
 * instancia y dos drawers leyendo el mismo store duplicarían el cobro.
 * Se carga perezoso y solo cuando hay un checkout abierto.
 */
const GlobalCheckoutHost = () => {
  const open = useCheckoutStore((s) => s.open);
  const { pathname } = useLocation();
  if (!open || pathname.startsWith(BASE_ROUTE)) return null;
  return (
    <Suspense fallback={null}>
      <CheckoutDrawer />
    </Suspense>
  );
};

export default GlobalCheckoutHost;
